import styled from 'styled-components';
import Button from 'app/commonComponents/Button';
import { SuccessIcon } from 'app/commonComponents/icons';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 1.25rem;
  padding: 3rem 1.5rem;
  border-left: none;
  color: ${colors.pacificBlue};

  ${media.mediumDesktop`
    border-left: 1px solid ${colors.gallery};
    padding: 3rem 0 0 1.5rem;
  `}
`;
export const HeaderBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -20px;
`;
export const CheckIcon = styled.div.attrs(() => ({
  'aria-hidden': true,
}))`
  background: #fff;
  padding: 0 15px;
  display: inline-block;
`;
export const ReturnButton = styled(Button)`
  margin: 0 auto 1rem auto;
  padding: 0.75rem 4rem;
  border-radius: 10px;
  width: 100%;
`;
export const StyledSuccessIcon = styled(SuccessIcon)`
  width: 2.5rem;
  height: 2.5rem;

  ${media.mediumDesktop`
    width: 5rem;
    height: 5rem;
  `}
`;
